import React, { useEffect, useRef, useState } from 'react';
import './InteractiveAvatar.css';

// URLs аватаров для разных коучей (по coachId)
const avatarUrlsByCoachId = {
  1: "https://labs.heygen.com/guest/streaming-embed?share=eyJxdWFsaXR5IjoiaGlnaCIsImF2YXRhck5hbWUiOiJjYTY1NWNlZWQ5ZTI0YjBlYWI4Mjk1MGI0NjRjOGUxNyIsInByZXZpZXdJbWciOiJodHRwczovL2ZpbGVzMi5oZXlnZW4uYWkvYXZhdGFyL3YzL2NhNjU1Y2VlZDllMjRiMGVhYjgyOTUwYjQ2NGM4ZTE3L2Z1bGwvMi4yL3ByZXZpZXdfdGFyZ2V0LndlYnAiLCJuZWVkUmVtb3ZlQmFja2dyb3VuZCI6ZmFsc2UsImtub3dsZWRnZUJhc2VJZCI6IjJkY2QyZTg3NjcxNzQ3ZWZhYWFhZWFkNzgxMGUyMzBiIiwidXNlcm5hbWUiOiI4YmY1MWVmMTU2MzY0OWMzYjhjZWU1NDkzNWY0NmRjMyJ9&inIFrame=1", // Ashley Copley
  2: "https://labs.heygen.com/guest/streaming-embed?share=eyJxdWFsaXR5IjoiaGlnaCIsImF2YXRhck5hbWUiOiJhMjQ2NTc5MmJjOGU0YjgwODA1Mzc2Mjc4%0D%0AMzg5Mzg2ZSIsInByZXZpZXdJbWciOiJodHRwczovL2ZpbGVzMi5oZXlnZW4uYWkvYXZhdGFyL3Yz%0D%0AL2EyNDY1NzkyYmM4ZTRiODA4MDUzNzYyNzgzODkzODZlL2Z1bGwvMi4yL3ByZXZpZXdfdGFyZ2V0%0D%0ALndlYnAiLCJuZWVkUmVtb3ZlQmFja2dyb3VuZCI6ZmFsc2UsImtub3dsZWRnZUJhc2VJZCI6ImRl%0D%0AbW8tMSIsInVzZXJuYW1lIjoiOGJmNTFlZjE1NjM2NDljM2I4Y2VlNTQ5MzVmNDZkYzMifQ%3D%3D&inIFrame=1" // Michael Legge
};

// URLs аватаров по heygenAvatar ID
const avatarUrlsByAvatarId = {
  "ca655ceed9e24b0eab82950b464c8e17": "https://labs.heygen.com/guest/streaming-embed?share=eyJxdWFsaXR5IjoiaGlnaCIsImF2YXRhck5hbWUiOiJjYTY1NWNlZWQ5ZTI0YjBlYWI4Mjk1MGI0NjRjOGUxNyIsInByZXZpZXdJbWciOiJodHRwczovL2ZpbGVzMi5oZXlnZW4uYWkvYXZhdGFyL3YzL2NhNjU1Y2VlZDllMjRiMGVhYjgyOTUwYjQ2NGM4ZTE3L2Z1bGwvMi4yL3ByZXZpZXdfdGFyZ2V0LndlYnAiLCJuZWVkUmVtb3ZlQmFja2dyb3VuZCI6ZmFsc2UsImtub3dsZWRnZUJhc2VJZCI6IjJkY2QyZTg3NjcxNzQ3ZWZhYWFhZWFkNzgxMGUyMzBiIiwidXNlcm5hbWUiOiI4YmY1MWVmMTU2MzY0OWMzYjhjZWU1NDkzNWY0NmRjMyJ9&inIFrame=1", // Ashley Copley
  "a2465792bc8e4b80805376278389386e": "https://labs.heygen.com/guest/streaming-embed?share=eyJxdWFsaXR5IjoiaGlnaCIsImF2YXRhck5hbWUiOiJhMjQ2NTc5MmJjOGU0YjgwODA1Mzc2Mjc4%0D%0AMzg5Mzg2ZSIsInByZXZpZXdJbWciOiJodHRwczovL2ZpbGVzMi5oZXlnZW4uYWkvYXZhdGFyL3Yz%0D%0AL2EyNDY1NzkyYmM4ZTRiODA4MDUzNzYyNzgzODkzODZlL2Z1bGwvMi4yL3ByZXZpZXdfdGFyZ2V0%0D%0ALndlYnAiLCJuZWVkUmVtb3ZlQmFja2dyb3VuZCI6ZmFsc2UsImtub3dsZWRnZUJhc2VJZCI6ImRl%0D%0AbW8tMSIsInVzZXJuYW1lIjoiOGJmNTFlZjE1NjM2NDljM2I4Y2VlNTQ5MzVmNDZkYzMifQ%3D%3D&inIFrame=1" // Michael Legge
};

const InteractiveAvatar = ({ coachId, avatarId, onSessionEnd }) => {
  const containerRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSessionActive, setIsSessionActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isConversationActive, setIsConversationActive] = useState(false);



  // Функции для управления сессией
  const handleExpandToggle = () => {
    const newExpandedState = !isExpanded;
    setIsExpanded(newExpandedState);

    // Находим контейнер аватара и применяем класс
    const wrapDiv = containerRef.current?.querySelector('.heygen-streaming-embed');

    if (wrapDiv) {
      if (newExpandedState) {
        wrapDiv.classList.add('expanded-fullscreen');
      } else {
        wrapDiv.classList.remove('expanded-fullscreen');
      }
    }

    // Управляем прокруткой страницы
    if (newExpandedState) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const handleEndSession = () => {
    // Сбрасываем состояние
    setIsSessionActive(false);
    setIsConversationActive(false);
    setIsLoading(true);

    // Если был полноэкранный режим, сворачиваем его
    if (isExpanded) {
      setIsExpanded(false);
      const wrapDiv = containerRef.current?.querySelector('.heygen-streaming-embed');
      if (wrapDiv) {
        wrapDiv.classList.remove('expanded-fullscreen');
      }
    }

    // Восстанавливаем прокрутку
    document.body.style.overflow = 'auto';

    // Перезагружаем iframe - находим и перезагружаем
    const iframe = containerRef.current?.querySelector('iframe');
    if (iframe) {
      const currentSrc = iframe.src;
      iframe.src = 'about:blank'; // Сначала очищаем
      setTimeout(() => {
        iframe.src = currentSrc; // Затем перезагружаем с исходным URL
      }, 100);
    }

    // Вызываем callback если он предоставлен
    if (onSessionEnd) {
      onSessionEnd();
    }
  };

  useEffect(() => {
    if (!containerRef.current) return;

    // Store container reference for cleanup
    const containerElement = containerRef.current;

    // Clear previous avatar if exists
    const existingAvatar = containerElement.querySelector('.heygen-streaming-embed');
    if (existingAvatar) {
      existingAvatar.remove();
    }

    // Get URL for current coach
    let avatarUrl;
    if (avatarId) {
      // If avatarId is provided, use it
      avatarUrl = avatarUrlsByAvatarId[avatarId];
    } else if (coachId) {
      // If coachId is provided, use it
      avatarUrl = avatarUrlsByCoachId[coachId];
    }

    // Fallback to Ashley Copley
    if (!avatarUrl) {
      avatarUrl = avatarUrlsByCoachId[1];
    }

    // Создаем элементы для аватара
    const wrapDiv = document.createElement("div");
    wrapDiv.className = "heygen-streaming-embed";

    const container = document.createElement("div");
    container.className = "heygen-streaming-container";

    const stylesheet = document.createElement("style");
    stylesheet.innerHTML = `
      .heygen-streaming-embed {
        z-index: 1;
        position: relative;
        width: 100%;
        height: 400px;
        border-radius: 8px;
        border: 2px solid #e5e7eb;
        box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.12);
        transition: all 0.3s ease-in-out;
        overflow: hidden;
        opacity: 0;
        visibility: hidden;
      }
      .heygen-streaming-embed.show {
        opacity: 1;
        visibility: visible;
      }
      .heygen-streaming-embed.expand {
        height: 500px;
        border-radius: 8px;
      }
      .heygen-streaming-embed.expanded-fullscreen {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 9999;
        border-radius: 0;
        border: none;
        box-shadow: none;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.9);
      }
      .heygen-streaming-embed.expanded-fullscreen .heygen-streaming-container {
        width: auto;
        height: 90vh;
        max-width: 90vw;
        aspect-ratio: 16/9;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      .heygen-streaming-embed.expanded-fullscreen .heygen-streaming-container iframe {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
      .heygen-streaming-container {
        width: 100%;
        height: 100%;
      }
      .heygen-streaming-container iframe {
        width: 100%;
        height: 100%;
        border: 0;
      }
      .fullscreen-controls {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
        display: flex;
        gap: 8px;
      }
      .fullscreen-control-btn {
        background: rgba(0, 0, 0, 0.8);
        color: white;
        border: none;
        border-radius: 8px;
        padding: 10px 16px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        transition: background-color 0.3s;
        display: flex;
        align-items: center;
        gap: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      }
      .fullscreen-control-btn:hover {
        background: rgba(0, 0, 0, 0.95);
        transform: scale(1.05);
      }
    `;

    const iframe = document.createElement("iframe");
    iframe.allowFullscreen = false;
    iframe.title = "Streaming Embed";
    iframe.role = "dialog";
    iframe.allow = "microphone";
    iframe.src = avatarUrl;

    let visible = false;
    let initial = false;

    // Обработчик сообщений от iframe
    const handleMessage = (e) => {
      if (e.origin === "https://labs.heygen.com" && e.data && e.data.type && "streaming-embed" === e.data.type) {
        console.log('Avatar message:', e.data.action); // Для отладки

        if ("init" === e.data.action) {
          initial = true;
          setIsSessionActive(true);
          setIsLoading(false);
          wrapDiv.classList.toggle("show", initial);

          // Fallback: если не получаем события о начале разговора, 
          // активируем кнопку End Session через 5 секунд после инициализации
          setTimeout(() => {
            setIsConversationActive(true);
          }, 5000);

        } else if ("show" === e.data.action) {
          visible = true;
          wrapDiv.classList.toggle("expand", visible);
        } else if ("hide" === e.data.action) {
          visible = false;
          wrapDiv.classList.toggle("expand", visible);
        } else if ("avatar_start_talking" === e.data.action) {
          // Аватар начал говорить - активная сессия
          setIsConversationActive(true);
        } else if ("user_start_talking" === e.data.action) {
          // Пользователь начал говорить - активная сессия
          setIsConversationActive(true);
        } else if ("conversation_started" === e.data.action) {
          // Разговор начался
          setIsConversationActive(true);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    // Добавляем обработчик клика для определения начала взаимодействия
    const handleIframeInteraction = () => {
      // Устанавливаем небольшую задержку, чтобы дать время на инициализацию разговора
      setTimeout(() => {
        setIsConversationActive(true);
      }, 2000);
    };

    iframe.addEventListener('load', () => {
      // Когда iframe загружен, добавляем обработчик клика
      try {
        iframe.contentWindow?.addEventListener('click', handleIframeInteraction);
      } catch (e) {
        // Если не можем получить доступ к contentWindow (из-за CORS), 
        // используем таймер как fallback
        console.log('Cannot access iframe content, using fallback method');
      }
    });

    // Собираем элементы
    container.appendChild(iframe);
    wrapDiv.appendChild(stylesheet);
    wrapDiv.appendChild(container);
    containerElement.appendChild(wrapDiv);

    // Cleanup функция
    return () => {
      window.removeEventListener("message", handleMessage);
      const avatar = containerElement?.querySelector('.heygen-streaming-embed');
      if (avatar) {
        avatar.remove();
      }
      // Восстанавливаем прокрутку при размонтировании
      document.body.style.overflow = 'auto';
    };
  }, [coachId, avatarId]);

  return (
    <div className="relative">
      {/* Loading indicator */}
      {isLoading && (
        <div className="avatar-loading">
          <div className="text-center">
            <div className="avatar-loading-spinner mb-3"></div>
            <p className="text-gray-600">Loading avatar...</p>
          </div>
        </div>
      )}



      {/* Control buttons as React components */}
      {isSessionActive && !isLoading && (
        <div
          className={isExpanded
            ? "fixed top-5 right-5 z-[10001] flex gap-2"
            : "absolute top-2 right-2 z-10 flex gap-2"
          }
        >
          <button
            onClick={handleExpandToggle}
            className={isExpanded
              ? "bg-black bg-opacity-80 hover:bg-opacity-95 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 shadow-lg"
              : "bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm font-medium transition-colors flex items-center gap-1"
            }
          >
            {isExpanded ? '🗗 Minimize' : '🗖 Fullscreen'}
          </button>

          {/* End Session button only shows when conversation is active */}
          {isConversationActive && (
            <button
              onClick={handleEndSession}
              className={isExpanded
                ? "bg-red-600 bg-opacity-80 hover:bg-opacity-95 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2 shadow-lg"
                : "bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm font-medium transition-colors flex items-center gap-1"
              }
            >
              ✕ End Session
            </button>
          )}
        </div>
      )}

      <div
        ref={containerRef}
        className="w-full h-full min-h-[400px] avatar-container"
        style={{ minHeight: '400px' }}
      />
    </div>
  );
};

export default InteractiveAvatar;
